var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-icon-button-wrapper",style:(_vm.wrapperStyle[_vm.size]),on:{"click":_vm.clicked}},[_c('span',{class:['icon', 'icon-' + _vm.icon],style:(Object.assign(_vm.iconStyle[_vm.size],{color: _vm.iconColor}))})])
}
var staticRenderFns = []

export { render, staticRenderFns }